import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Table, TableModule } from 'primeng/table';
import { Subscription } from 'rxjs';
import { PATH_PATIENTS, PATH_PATIENT_DASHBOARD } from 'src/app/patients/patients.global';
import { selectUser } from 'src/app/calvin-emr-shared/state/auth/auth.selector';
import { Patient } from '../../calvin-emr-shared/models/patient.model';
import { User } from '../../calvin-emr-shared/models/user.model';
import { PrimeTemplate } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';

@Component({
  selector: 'app-patient-table',
  templateUrl: './patient-table.component.html',
  styleUrls: ['./patient-table.component.scss'],
  standalone: true,
  imports: [
    TableModule,
    PrimeTemplate,
    InputTextModule,
    NgIf,
    ButtonDirective,
    TooltipModule,
    IconField,
    InputIcon,
  ],
})
export class PatientTableComponent implements OnInit, OnDestroy {
  currentUser: User = new User();
  currentUserSub: Subscription;

  /**
   * The PrimeNG table HTML element.
   */
  @ViewChild('patientTable') patientTable: Table | undefined;

  /**
   * The fields to filter the table by when using the search bar.
   */
  tableFilterFields: string[] = ['mrn', 'id', 'firstName', 'lastName'];

  @Input() loading = false;

  /**
   * Array of all patients held by the current user.
   */
  @Input() patients: Patient[] = [];

  @Input() selectedPatients: Patient[] = [];
  // vtn2 NOTE: this special syntax (adding "Change" to the end of the name)
  // allows us to emit an event when the selected patients change. I.e., 2-way binding.
  @Output() selectedPatientsChange = new EventEmitter<Patient[]>();

  constructor(private router: Router, private store: Store) {
    this.currentUserSub = store.select(selectUser).subscribe((user: User | null) => {
      if (user) {
        this.currentUser = user;
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.currentUserSub.unsubscribe();
  }
  /**
   * Filters the data in the table based on the text in the search field
   * HTML input element. The data is filtered based on whether the any
   * of the fields in the tableFilterFields array contain the text.
   *
   * @param target The search field HTML input element.
   */
  filterTable(target: EventTarget | null) {
    if (target) {
      this.patientTable?.filterGlobal((target as HTMLInputElement).value, 'contains');
    }
  }

  onRowSelect(event: any) {
    const patient = event.data as Patient;
    this.selectedPatientsChange.emit([patient, ...this.selectedPatients]);
  }

  onRowUnselect(event: any) {
    const patient = event.data as Patient;
    this.selectedPatientsChange.emit(this.selectedPatients.filter((p) => p.id !== patient.id));
  }

  /**
   * Route to the patient page with the clicked row's patient id.
   *
   * @param {string} id The ID of the patient to route to.
   */
  navigateToPatient(id: string) {
    this.router.navigate([PATH_PATIENTS, PATH_PATIENT_DASHBOARD, this.currentUser.role, id]);
  }

  get isAdmin() {
    return this.currentUser.isAdmin;
  }
}
